(() => {
function parseInventory(picker) {
const script = picker.querySelector('script[data-variant-inventory]');
if (!script) return null;

const low = Number(script.getAttribute('data-inv-low') || 5);
const crit = Number(script.getAttribute('data-inv-crit') || 3);

let variants = [];
try { variants = JSON.parse(script.textContent || '[]'); } catch(e) {}

return { low, crit, variants };
}

function getSelectedValues(picker) {
const selected = [];
picker.querySelectorAll('input[type="radio"][name*="option"]').forEach(el => {
if (el.checked) selected.push(el.value);
});
picker.querySelectorAll('select[name*="option"]').forEach(el => selected.push(el.value));
return selected;
}

function qtyFor(inv, pos, val, selected) {
const idx = Number(pos) - 1;

// Kandidaten: gleiche Option (z.B. Farbe)
let candidates = inv.variants.filter(v => (v.options?.[idx] || '') === val);

// Wenn weitere Optionen (z.B. Größe) gewählt sind, so gut wie möglich matchen
if (selected.length) {
candidates = candidates.filter(v =>
v.options?.every((opt, i) => i === idx || !selected[i] || selected[i] === opt)
);
}

if (!candidates.length) return null;

// konservativ: Minimum über Kandidaten
return Math.min(...candidates.map(v => Number(v.inventory_quantity || 0)));
}

function apply(el, inv, qty) {
if (qty === null) return;

let state = 'ok';
let title = '';

if (qty <= 0) {
state = 'out';
title = 'Ausverkauft';
} else if (qty <= inv.crit) {
state = 'crit';
title = `Kritisch: nur noch ${qty} auf Lager`;
} else if (qty <= inv.low) {
state = 'low';
title = `Nur noch ${qty} auf Lager`;
}

el.dataset.invState = state;
if (title) el.setAttribute('title', title);
else el.removeAttribute('title');
}

function update(picker) {
const inv = parseInventory(picker);
if (!inv) return;

const selected = getSelectedValues(picker);

picker.querySelectorAll('[data-inv-swatch]').forEach(el => {
const pos = el.getAttribute('data-option-position');
const val = el.getAttribute('data-option-value');
const qty = qtyFor(inv, pos, val, selected);
apply(el, inv, qty);
});
}

// Anti-Anker-Springen im Picker
document.addEventListener('click', (e) => {
const a = e.target.closest('a');
if (!a) return;
if (!a.closest('variant-picker')) return;

const href = a.getAttribute('href') || '';
if (href.startsWith('#')) e.preventDefault();
});

document.addEventListener('DOMContentLoaded', () => {
document.querySelectorAll('variant-picker').forEach(picker => {
update(picker);

picker.addEventListener('change', () => {
const y = window.scrollY; // Scrollposition merken
update(picker);
requestAnimationFrame(() => window.scrollTo(0, y)); // wieder zurück
});
});
});
})();